import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import type { AllowedUser, UserRole } from '@/types';

interface UpsertAllowedUserInput {
  email: string;
  role: UserRole;
  isActive: boolean;
}

export const listAllowedUsers = async (): Promise<AllowedUser[]> => {
  const callable = httpsCallable(functions, 'listAllowedUsers');
  const response = await callable();
  const data = response.data as { users: AllowedUser[] };
  return data.users || [];
};

export const upsertAllowedUser = async (
  input: UpsertAllowedUserInput
): Promise<AllowedUser> => {
  const callable = httpsCallable(functions, 'upsertAllowedUser');
  const response = await callable(input);
  const data = response.data as { user: AllowedUser };
  return data.user;
};
